<template>
  <div class="popup_wrap">
    <div class="popup_box">
      <div class="popup_msg" v-html="$tc('phone_double_check')"></div>
      <div class="btn_wrap">
        <button @click="$emit('phoneCheckControl', 'retry')" class="btn_retry">{{ $tc("re_enter") }}</button>
        <button @click="$emit('phoneCheckControl', 'confirm')" class="btn_confirm">{{ $tc("register_anyway") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PhoneCheckPopup'
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";

.popup_wrap {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
}

.popup_box {
  display: flex;
  width: 66.40625vw;
  padding: 7.5vh 3.90625vw 6.25vh;
  flex-direction: column;
  @include flex-gap(5vh, column);
  border-radius: 2.5vw;
  border: 1px solid $e0;
  background: $white;
}

.popup_msg {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 19.875vh;
  color: $black;
  text-align: center;
  font-size: 36px; // IE11 fallback
  font-size: unquote("min(2.8125vw, 36px)");
  font-weight: 700;
  line-height: 6.625vh;
}

.btn_wrap {
  display: flex;
  @include flex-gap(1.5625vw, row);
  button {
    width: 100%;
    height: 11.75vh;
    padding: 3.25vh 0.78125vw;
    justify-content: center;
    align-items: center;
    border-radius: 1.5625vw;
    background: #E6E8EB;
    color: #2E3137;
    font-size: 32px; // IE11 fallback
    font-size: unquote("min(2.5vw, 32px)");
    font-weight: 700;
    line-height: 4.75vh;
  }
  .btn_confirm {
    background: #D81B1B;
    color: $white;
  }
}
</style>
